import { BaseResponse, request } from "@/lib/request";
import { localizeHref } from "@/paraglide/runtime";

export interface OAuthUrlResponse {
	auth_url: string;
}

// http://localhost:3000/cn/story/87e6131f-1621-44e7-aa88-2f034cbc3a83/-?inviteCode=PAHJ2F3
// http://localhost:3000/cn/story/87e6131f-1621-44e7-aa88-2f034cbc3a83/c4e80c96-5854-4db6-b98c-bdf44be6e7e8?shared=true&inviteCode=PAHJ2F3

export async function getOAuthUrl(
	auth_type: string,
): Promise<BaseResponse<OAuthUrlResponse>> {
	return request.get("/user-center/oauth2/url", {
		auth_type, //google/twitter/discord
		redirect_url: localizeHref(`${window.location.origin}/auth/social`),
		redirect_params: location.pathname + location.search,
		invite_code: localStorage.getItem("INVITE_CODE") || "",
	});
}

export interface EmailLoginResponse {
	token: string;
}

export async function commonLogin(
	auth_type: "email" | "telegram",
	auth_data:
		| {
				code: string;
				email: string;
		  }
		| any,
): Promise<BaseResponse<EmailLoginResponse>> {
	return request.post("/user-center/common/login", {
		auth_type,
		auth_data: JSON.stringify(auth_data),
		invite_code: localStorage.getItem("INVITE_CODE") || "",
	});
}

export async function sendEmailLink(
	email: string,
): Promise<BaseResponse<null>> {
	console.log("sendEmailLink", email);
	return request.post("/user-center/auth_otp/send", {
		auth_type: "email",
		otp_type: "link",
		redirect_url: localizeHref(`${window.location.origin}/auth/email`),
		redirect_params: location.pathname + location.search,
		email,
		invite_code: localStorage.getItem("INVITE_CODE") || "",
	});
}

export interface UserInfoResponse {
	user_id: string;
	name: string;
	avatar: string;
	email?: string;
	gem?: number;
	login_type?: string;
	third_user_info?: {
		email: string;
		name: string;
		third_id: string;
	};
	member_level?: string;
	member_start_time?: number;
	member_end_time?: number;
	invite_code?: string;
}

export async function getUserInfo(): Promise<BaseResponse<UserInfoResponse>> {
	return request.get("/aifk/user/profile");
}

export async function getUserGem(): Promise<
	BaseResponse<{ user_id: string; gem: string }>
> {
	return request.get("/aifk/user/info");
}
